import { apiGet, apiPost } from '../../../utils/api';

const SA = '/api/super-admin';

// ─── Marketplace Overview ────────────────────────────────────────────────────
export const fetchMarketplaceOverview = () => apiGet<any>(`${SA}/marketplace/overview`);

// ─── Tenant Entitlements ────────────────────────────────────────────────────
export const listMarketplaceTenants = (params?: Record<string, any>) =>
  apiGet<any>(`${SA}/marketplace/tenants`, params || {});
export const getTenantMarketplaceDetail = (id: number) =>
  apiGet<any>(`${SA}/marketplace/tenants/${id}`);
export const enableMarketplaceAccess = (id: number, data: any) =>
  apiPost<any>(`${SA}/marketplace/tenants/${id}/enable`, data);
export const suspendMarketplaceAccess = (id: number, reason: string) =>
  apiPost<any>(`${SA}/marketplace/tenants/${id}/suspend`, { reason });
export const revokeMarketplaceAccess = (id: number, reason: string) =>
  apiPost<any>(`${SA}/marketplace/tenants/${id}/revoke`, { reason });

// ─── Supplier Verification ──────────────────────────────────────────────────
export const listPendingVerifications = () =>
  apiGet<any>(`${SA}/marketplace/verifications`);
export const getVerificationDetail = (id: number) =>
  apiGet<any>(`${SA}/marketplace/verifications/${id}`);
export const reviewSupplierVerification = (id: number, decision: string, reason?: string) =>
  apiPost<any>(`${SA}/marketplace/verifications/${id}/review`, { decision, reason });

// ─── Settings ───────────────────────────────────────────────────────────────
export const fetchMarketplaceSettings = () =>
  apiGet<any>(`${SA}/marketplace/settings`);
export const updateMarketplaceSetting = (key: string, value: any) =>
  apiPost<any>(`${SA}/marketplace/settings`, { key, value });

// ─── Listings Oversight ─────────────────────────────────────────────────────
export const listAllListings = (params?: Record<string, any>) =>
  apiGet<any>(`${SA}/marketplace/listings`, params || {});

// ─── Orders & Fulfilment ────────────────────────────────────────────────────
export const listAllBuyerOrders = (params?: Record<string, any>) =>
  apiGet<any>(`${SA}/marketplace/buyer-orders`, params || {});
export const getBuyerOrderDetail = (id: number) =>
  apiGet<any>(`${SA}/marketplace/buyer-orders/${id}`);
export const listAllSupplierOrders = (params?: Record<string, any>) =>
  apiGet<any>(`${SA}/marketplace/supplier-orders`, params || {});
export const getSupplierOrderDetail = (id: number) =>
  apiGet<any>(`${SA}/marketplace/supplier-orders/${id}`);

// ─── Shipments ──────────────────────────────────────────────────────────────
export const listAllShipments = (params?: Record<string, any>) =>
  apiGet<any>(`${SA}/marketplace/shipments`, params || {});

// ─── Invoices ───────────────────────────────────────────────────────────────
export const listAllInvoices = (params?: Record<string, any>) =>
  apiGet<any>(`${SA}/marketplace/invoices`, params || {});

// ─── Settlements ────────────────────────────────────────────────────────────
export const listAllSettlements = (params?: Record<string, any>) =>
  apiGet<any>(`${SA}/marketplace/settlements`, params || {});

// ─── Disputes ───────────────────────────────────────────────────────────────
export const listAllDisputes = (params?: Record<string, any>) =>
  apiGet<any>(`${SA}/marketplace/disputes`, params || {});

// ─── Audit Events ───────────────────────────────────────────────────────────
export const listMarketplaceAuditEvents = (params?: Record<string, any>) =>
  apiGet<any>(`${SA}/marketplace/audit-events`, params || {});
